import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FieldFooter } from '../FieldFooter';
import { Label } from '../Label';
import { Input, InputRow, Wrapper } from './Textarea.styles';
/**
 * Ref needs to be forwarded to be compatible with form packages like react-hook-form.
 */ export const Textarea = /*#__PURE__*/ forwardRef(({ className, icon, isDisabled, label, name, statusLabel, statusType, ...props }, ref)=>/*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        children: [
            Boolean(label) && /*#__PURE__*/ _jsx(Label, {
                htmlFor: name ?? '',
                isBold: true,
                children: label
            }),
            /*#__PURE__*/ _jsx(InputRow, {
                $isDisabled: isDisabled,
                $statusType: statusType,
                children: /*#__PURE__*/ _jsx(Input, {
                    ...props,
                    "aria-invalid": statusType === 'error',
                    disabled: isDisabled,
                    name: name,
                    ref: ref
                })
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                fieldFooterLabel: statusLabel,
                fieldFooterType: statusType,
                icon: icon
            })
        ]
    }));

//# sourceMappingURL=Textarea.js.map